<template>
<div class="chapter">
<div class="inner_page">
<p class="C143_12"><a id="page_vii">CONTENTS</a></p><a id="page_vii">
</a><p class="C144"><a id="page_vii"></a><a href="#/xhtml/06_1__First#page_1"><em>Chapter 1</em>. FIRST IMPRESSIONS</a></p>
<p class="C144"><a href="#/xhtml/07_2__Probi#page_20"><em>Chapter 2</em>. PROBINGS</a></p>
<p class="C144"><span href="#/xhtml/08_3__Arab#page_37" title="Link target outside of Sample"><em>Chapter 3</em>. ARAB AFFAIRS ANALYST OF SORTS</span></p>
<p class="C144"><span href="#/xhtml/09_4__Rache#page_49" title="Link target outside of Sample"><em>Chapter 4</em>. RACHEL</span></p>
<p class="C144"><span href="#/xhtml/10_5__The_L#page_68" title="Link target outside of Sample"><em>Chapter 5</em>. THE LEVANTINISM SCARE</span></p>
<p class="C144"><span href="#/xhtml/11_6__The_T#page_91" title="Link target outside of Sample"><em>Chapter 6</em>. THE THREE DIVIDES</span></p>
<p class="C144"><span href="#/xhtml/12_7__Barba#page_111" title="Link target outside of Sample"><em>Chapter 7</em>. BARBARIANS AT THE GATE</span></p>
<p class="C144"><span href="#/xhtml/13_8__Gentl#page_137" title="Link target outside of Sample"><em>Chapter 8</em>. GENTLEFOLK AND UPSTARTS</span></p>
<p class="C144"><span href="#/xhtml/14_9__Israe#page_157" title="Link target outside of Sample"><em>Chapter 9</em>. ISRAEL’S COMMUNAL PROBLEM</span></p>
<p class="C144"><span href="#/xhtml/15_10__Free#page_173" title="Link target outside of Sample"><em>Chapter 10</em>. FREEDOM OF SPEECH, ISRAEL STYLE</span></p>
<p class="C144"><span href="#/xhtml/16_11__The#page_190" title="Link target outside of Sample"><em>Chapter 11</em>. THE MYSTERY OF EDUCATION</span></p>
<p class="C144"><span href="#/xhtml/17_12__The#page_202" title="Link target outside of Sample"><em>Chapter 12</em>. THE DEBATE INTENSIFIES</span></p>
<p class="C824"><span href="#/xhtml/18_13__Step#page_219" title="Link target outside of Sample"><em>Chapter 13</em>. STEPPING ON “VERY DELICATE GROUND”</span></p>
<p class="C119"><span href="#/xhtml/19_Afterwor#page_239" title="Link target outside of Sample">AFTERWORD</span></p>
<p class="C144"><em><span href="#/xhtml/19_Afterwor#page_239" title="Link target outside of Sample">Pride or Self-Effacement: On Refusing to Save Skin</span></em></p>
<p class="C119"><span href="#/xhtml/20_Index#page_243" title="Link target outside of Sample">INDEX</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 04_Contents.vue?d36d2634